// Send / history
export const SEND_BOOST_MESSAGE = 'SEND_BOOST_MESSAGE';
export const SEND_BOOST_BULK = 'SEND_BOOST_BULK';
// Pre-send segment/cost estimate for the confirm dialog.
export const FETCH_BOOST_COST_ESTIMATE = 'FETCH_BOOST_COST_ESTIMATE';
export const STORE_BOOST_COST_ESTIMATE = 'STORE_BOOST_COST_ESTIMATE';
export const STORE_BOOST_ESTIMATING = 'STORE_BOOST_ESTIMATING';
export const CLEAR_BOOST_COST_ESTIMATE = 'CLEAR_BOOST_COST_ESTIMATE';
export const FETCH_BOOST_SCHEDULE_AVAILABILITY =
  'FETCH_BOOST_SCHEDULE_AVAILABILITY';
export const STORE_BOOST_SCHEDULE_AVAILABILITY =
  'STORE_BOOST_SCHEDULE_AVAILABILITY';
export const RETRY_BOOST_MESSAGE = 'RETRY_BOOST_MESSAGE';
export const RETRY_BOOST_RECIPIENT = 'RETRY_BOOST_RECIPIENT';
export const CANCEL_BOOST_MESSAGE = 'CANCEL_BOOST_MESSAGE';
export const FETCH_BOOST_HISTORY = 'FETCH_BOOST_HISTORY';
export const STORE_BOOST_HISTORY = 'STORE_BOOST_HISTORY';
export const FETCH_BOOST_DETAIL = 'FETCH_BOOST_DETAIL';
export const STORE_BOOST_DETAIL = 'STORE_BOOST_DETAIL';
export const STORE_BOOST_SENDING = 'STORE_BOOST_SENDING';
export const STORE_BOOST_SEND_RESULT = 'STORE_BOOST_SEND_RESULT';
export const CLEAR_BOOST_DETAIL = 'CLEAR_BOOST_DETAIL';

// Home-screen history accordion, paged one status bucket at a time (20
// per page, newest first). Separate from FETCH_BOOST_HISTORY, which still
// loads the whole set the spend/opt-out tiles and Analytics are computed
// from - only the accordion LIST is paged.
export const FETCH_BOOST_HISTORY_PAGE = 'FETCH_BOOST_HISTORY_PAGE';
export const STORE_BOOST_HISTORY_PAGE = 'STORE_BOOST_HISTORY_PAGE';
export const STORE_BOOST_HISTORY_PAGE_LOADING =
  'STORE_BOOST_HISTORY_PAGE_LOADING';

// Audience / customers
export const FETCH_BOOST_CUSTOMERS = 'FETCH_BOOST_CUSTOMERS';
export const STORE_BOOST_CUSTOMERS = 'STORE_BOOST_CUSTOMERS';
// Take a number back off the Do Not Send list (Bad Numbers 2192 Restore).
export const CLEAR_BOOST_INVALID_NUMBER = 'CLEAR_BOOST_INVALID_NUMBER';

// Templates
export const FETCH_BOOST_TEMPLATES = 'FETCH_BOOST_TEMPLATES';
export const SAVE_BOOST_TEMPLATE = 'SAVE_BOOST_TEMPLATE';
export const DELETE_BOOST_TEMPLATE = 'DELETE_BOOST_TEMPLATE';
export const STORE_BOOST_TEMPLATES = 'STORE_BOOST_TEMPLATES';

// Credit
export const FETCH_BOOST_CREDIT = 'FETCH_BOOST_CREDIT';
export const STORE_BOOST_CREDIT = 'STORE_BOOST_CREDIT';

// Settings
export const FETCH_BOOST_SETTINGS = 'FETCH_BOOST_SETTINGS';
export const SAVE_BOOST_SETTINGS = 'SAVE_BOOST_SETTINGS';
export const STORE_BOOST_SETTINGS = 'STORE_BOOST_SETTINGS';

// Admin (platform owner only)
export const FETCH_BOOST_ADMIN = 'FETCH_BOOST_ADMIN';
export const SAVE_BOOST_ADMIN = 'SAVE_BOOST_ADMIN';
export const RESET_BOOST_BALANCE = 'RESET_BOOST_BALANCE';
export const PAUSE_BOOST = 'PAUSE_BOOST';
export const STORE_BOOST_ADMIN = 'STORE_BOOST_ADMIN';

// Analytics
export const FETCH_BOOST_ANALYTICS = 'FETCH_BOOST_ANALYTICS';
export const STORE_BOOST_ANALYTICS = 'STORE_BOOST_ANALYTICS';

// Platform Config (ROLE_OWNER)
export const FETCH_BOOST_PLATFORM_CONFIG = 'FETCH_BOOST_PLATFORM_CONFIG';
export const SAVE_BOOST_PLATFORM_CONFIG = 'SAVE_BOOST_PLATFORM_CONFIG';
export const STORE_BOOST_PLATFORM_CONFIG = 'STORE_BOOST_PLATFORM_CONFIG';
